import { FieldEditorComponent } from './field-editor/field-editor.component';
import { CompanyEntitiesListComponent } from './company-entities-list/company-entities-list.component';
import { DetalleInformeComponent } from './detalle-informe/detalle-informe.component';
import { InformesComponent } from './informes/informes.component';
import { FramelinkViewerComponent } from './framelink-viewer/framelink-viewer.component';
import { UsuariosComponent } from './usuarios/usuarios.component';
import { CompanyEditorComponent } from './company-editor/company-editor.component';
import { CompaniesComponent } from './companies/companies.component';
import { RouterModule, Routes } from '@angular/router';
import { NgModule } from '@angular/core';

import { PagesComponent } from './pages.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { FrameLinksComponent } from './frame-links/frame-links.component';
import { UserEditorComponent } from './user-editor/user-editor.component';
import { FrameLinkEditorComponent } from './frame-link-editor/frame-link-editor.component';
import { CustomformsComponent } from './customforms/customforms.component';
import { EntitiesimporterComponent } from './entitiesimporter/entitiesimporter.component';
import { CustomformEditorComponent } from './customform-editor/customform-editor.component';
import { VisorInformeMapaComponent } from './visor-informe-mapa/visor-informe-mapa.component';
import { CustomentityComponent } from './customentity/customentity.component';
import { CustomentitiesComponent } from './customentities/customentities.component';

/**
 * Rutas de URLS
 */
const PAGES_ROUTES: Routes = [{
  path: '',
  component: PagesComponent,
  children: [
    {
      path: 'dashboard',
      component: DashboardComponent,
    },
    {
      path: 'company',
      component: CompaniesComponent,
    },
    {
      path: 'company/:company',
      component: CompanyEditorComponent,
    },
    {
      path: 'usuarios/:company',
      component: UsuariosComponent,
    },
    {
      path: 'framelinks/:company',
      component: FrameLinksComponent,
    },
    {
      path: 'framelink/:company/:framelink',
      component: FrameLinkEditorComponent,
    },
    {
      path: 'viewframelink/:urllink',
      component: FramelinkViewerComponent,
    },
    {
      path: 'visorinformemapa',
      component: VisorInformeMapaComponent,
    },
    {
      path: 'customforms',
      component: CustomformsComponent,
    },
    {
      path: 'customentities',
      component: CustomentitiesComponent,
    },
    {
      path: 'customform/:companyid/:idform',
      component: CustomformEditorComponent,
    },
    {
      path: 'systementities',
      component: EntitiesimporterComponent,
    },
    {
      path: '',
      redirectTo: 'dashboard',
      pathMatch: 'full',
    },
    {
      path: 'usuario/:company/:usuario',
      component: UserEditorComponent,
    },
    {
      path: 'informes/:report',
      component: InformesComponent,
    },
    {
      path:'informes/detalle/:tipo/:report',
      component: DetalleInformeComponent,
    },
    {
      path:'ajustes/:entidad',
      component: CompanyEntitiesListComponent,
    },
    {
      path:'parcela/:idParcela',
      component: FieldEditorComponent,
    },
    {
      path:'customentity/:idEntity',
      component: CustomentityComponent,
    },
    {
      path:'customentity/:idCompany/:idEntity',
      component: CustomentityComponent,
    },
  ],
}];

/**
 * Módulo que contiene la configuración de rutas
 */
@NgModule({
  imports: [RouterModule.forChild(PAGES_ROUTES)],
  exports: [RouterModule],
})
export class PagesRoutingModule {
}
